import { createFileRoute, redirect } from '@tanstack/react-router'
import { CreateAnnouncementsPage } from '../pages/announcements/CreateAnnouncementsPage'
import { msalInstance } from '../api/auth'

export const Route = createFileRoute('/create-announcements')({
  component: CreateAnnouncementsPage,
  beforeLoad: () => {
    const account = msalInstance.getActiveAccount()
    const roles = account?.idTokenClaims?.roles || []

    if (!roles.includes('Manage.All')) {
      throw redirect({
        to: '/',
        search: { error: 'insufficient_permissions' },
      })
    }
  },
  validateSearch: (search) => ({
    announcementId: typeof search.announcementId === 'string' ? search.announcementId : undefined,
  }),
})
